import request from '../utils/request';
import { REPORT_TYPES } from '../utils/reportTypes';
import { invalidateFeedSnapshots } from '../utils/searchFeedReturn';

export function isValidReactionId(id) {
  return /^[1-9]\d*$/.test(String(id)) && Number.isSafeInteger(Number(id)) && Number(id) <= 2147483647;
}

export function sendReactionReport(id, type) {
  if (!isValidReactionId(id) || !REPORT_TYPES.includes(type)) {
    return Promise.resolve({ success: false, statusCode: 400 });
  }
  // Keep the identifier in the URL: request() retains all supplied data in the body.
  const prefix = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  return request({ url: `${prefix}/reaction/${id}/report`, method: 'POST', data: { type } }).then(response => {
    if (response?.success) invalidateFeedSnapshots();
    return response;
  });
}
